<app-breadcrumbs></app-breadcrumbs>
<div class="store-number-toolbar">
  <div [cfaLoading]="isLoading">
    <button mat-raised-button color="primary" id="store-number-search-button" (click)="getDiagnostics()">
      <mat-icon>search</mat-icon>
    </button>
    <mat-form-field id="store-number-search-field" appearance="outline">
      <mat-label>Store Number</mat-label>
      <input matInput maxLength="5" minLength="5" [(ngModel)]="storeNumber" autofocus
        (keydown.enter)="getDiagnostics()"/>
    </mat-form-field>
    @if (circuitNotFound) {
      <div>Circuit not found! Try a different store number.</div>
    }
  </div>
</div>
<div id="links">
  @if (netboxLink != null) {
    <div id="netbox-url-link">
      <mat-icon matTooltip="View site in NetBox" id="netbox-icon">link</mat-icon>
      <a [href]="netboxLink" target="_blank">NetBox</a>
    </div>
  }
</div>
<div id="table-wrapper">
  <table mat-table #diagnosticsTable [dataSource]="diagnosticsDataSource" class="diagnostic-table mat-elevation-z8">
    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td class="type-cell" mat-cell *matCellDef="let diagnostic">{{diagnostic.disposition.type}}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td class="status-cell" mat-cell *matCellDef="let diagnostic">{{diagnostic.disposition.externalStatus.label}}</td>
    </ng-container>
    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef>Message</th>
      <td mat-cell *matCellDef="let diagnostic">{{diagnostic.disposition.message}}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="diagnosticsDisplayColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: diagnosticsDisplayColumns;"></tr>
  </table>
</div>